










































































































































































require("@c/Home/Services/ServiceAppoint/ServiceDetail/ServiceDetail.vue");
require("@c/Home/Services/ServiceCalendar/ServiceCalendar.vue");
require("@c/Home/Services/ServiceConfirmation/ServiceConfirmation.vue");

import HomeServicesComponent from "@c/Home/Services/ServiceComponent";
export default HomeServicesComponent;
